import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function MailUnread(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.416 6.548H4a1 1 0 00-.996.978l7.665 5.547c.793.635 1.85.636 2.606.038l2.892-2.09c.7.384 1.465.666 2.272.826l-3.957 2.858a3.971 3.971 0 01-2.474.86c-.897 0-1.8-.3-2.55-.902L3 9.99v8.186a1 1 0 001 1h15.845a1 1 0 001-1v-6.22a7.942 7.942 0 002-.478v6.698c0 1.654-1.346 3-3 3H4c-1.655 0-3-1.346-3-3V7.548c0-1.654 1.345-3 3-3h8.018c.048.694.184 1.365.398 2z",
    fill: props.color || "#222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
    fill: "#F81B40"
  }));
}

var MemoMailUnread = React.memo(MailUnread);
export default MemoMailUnread;